<template>
    <div 
        :class="{ 'scroller': true, '--large-bottom-padding': isLargeBottomPadding}"
    >
        <button
            v-show="isVisible"
            @click="toTop"
            :title="$t('scrollerAdditionalTitle')"
        >
            <svg><use xlink:href="@/themes/novaporta/assets/icons/sprite.svg#arrowRightIcon"></use></svg>
        </button>
    </div>
</template>

<script>

export default {
    name: 'Scroller',
    data() {
        return {
           isVisible: false
        }
    },
    computed: {
        isLargeBottomPadding() {
            let flag = false

            if (this.$route.path.includes('/product')) flag = true

            return flag
        }
    },
    methods: {
        handleScroll() {
            this.isVisible = window.scrollY > parseInt(this.$stylesVars['navigation-height'], 10) ? true : false
        },
        toTop() {
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })
            })
        },
    },
    mounted() {
        this.handleScroll()
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
};
</script>

<style lang="scss">
@import './styles.scss';
</style>
